// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"customsWarningBanner_flexWrapper__g5iVo","wrapper":"customsWarningBanner_wrapper__iLrQA"};